import React, { useState } from "react";
import Slider from "react-slick";
import { Box, Container, useMediaQuery } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../css/SliderStyles.css";
import TypographyComponent from "./TypographyComponent";
import Colors from "./Colors";
import PlayButtonComponent from "./PlayButtonComponent";
import CounterComponent from "./CounterComponent";
import TypographyComponentNormal from "./TypographyComponentNormal";
import cup from "../images_new/cup.svg";
import cupMobile from "../images_new/cupMob.svg";

const colors = [
  {
    gradient: "linear-gradient(to right, #0CD6FF, #DDF6FBF5, #87F3FFEB)",
    dotColor: "#0CD6FF",
  },
  {
    gradient: "linear-gradient(to right, #ECF5F6, #DDF6FBF5,#ECF5F6EB)",
    dotColor: "#ECF5F6",
  },
];

const SliderComponent = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const isMobile = useMediaQuery("(max-width:600px)");

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    beforeChange: (oldIndex, newIndex) => {
      setPrevIndex(oldIndex);
      setActiveIndex(newIndex);
    },
    appendDots: (dots) => (
      <ul>
        {dots.map((dot, index) => {
          const isShrinking = index === prevIndex;

          // Determine the expansion direction
          let expandDirection = "right"; // Default direction
          if (index === 0)
            expandDirection = "right"; // First dot expands to the right
          else if (index === dots.length - 1)
            expandDirection = "left"; // Last dot expands to the left
          else expandDirection = index % 2 === 0 ? "left" : "right"; // Alternate for middle dots

          return React.cloneElement(dot, {
            "data-active": index === activeIndex ? "true" : undefined,
            className: isShrinking ? "shrinking" : dot.props.className,
            style: {
              "--expand-direction": expandDirection,
            },
          });
        })}
      </ul>
    ),
  };

  return (
    <Container
      maxWidth={false} // Ensures it takes full width
      disableGutters
      sx={{
        width: "100%", // Or you can try "95%" for slight padding
        overflow: "visible",
        position: "relative",
        padding: "0px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
        borderRadius: 2,
        // px: '10px',
        //  mx: "10px",
        "--active-dot-color": colors[activeIndex]?.dotColor || "#0CD6FF",
      }}
    >
      <Slider {...settings} style={{ overflow: "visible" }}>
        {colors.map((item, index) => (
          <Box
            key={index}
            sx={{
              // m: "10px auto", // ✅ Centers the box horizontally
              width: "95%",
              flexDirection: "row",
              // width: '100%',
              height: 178,
              display: "flex !important",
              alignItems: "center",
              justifyContent: "space-between", // To ensure proper spacing
              backgroundImage: item.gradient,
              borderRadius: 2,
              fontSize: 18,
              fontWeight: "bold",
              overflow: "visible",
              // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
              backgroundColor: "white",
            }}
          >
            <Box
              sx={{
                width: { xs: "60%", md: "80%" },
                display: "flex",
                flexDirection: { md: "row", xs: "column" },
                height: 178,
                paddingLeft: { xs: "20px", md: 0 },
                justifyContent: { md: "space-between" },
              }}
            >
              <Box
                sx={{
                  width: { xs: "100%", md: "30%" },
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: { xs: "flex-start", md: "center" },
                  gap: { md: "10px", xs: "2px" },
                  order: { xs: 1, md: 1 },
                }}
              >
                <TypographyComponent sx={{ color: Colors.typoblue }}>
                  Rapid Riddle
                </TypographyComponent>
                <TypographyComponent
                  sx={{
                    color: Colors.typoblue2,
                    fontSize: { xs: "10", md: "20" },
                    lineHeight: { xs: "12px", md: "16px" },
                  }}
                >
                  Solve, Play, Win Big Rewards!"
                </TypographyComponent>
              </Box>
              <Box
                sx={{
                  width: { xs: "100%", md: "30%" },
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "10px",
                  alignItems: { xs: "flex-start", md: "center" },
                  order: { xs: 3, md: 2 },
                }}
              >
                <CounterComponent></CounterComponent>
                <PlayButtonComponent
                  sx={{
                    width: { md: "182px", xs: "96px" },
                    display: { xs: "none", md: "flex" },
                  }}
                ></PlayButtonComponent>
              </Box>
              <Box
                sx={{
                  width: { md: "35%", xs: "100%" },
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: { xs: "flex-start", md: "center" },
                  gap: { md: "10px", xs: "2px" },
                  order: { xs: 2, md: 3 },
                }}
              >
                <TypographyComponent
                  sx={{
                    color: Colors.orangeterTertiary,
                    textAlign: "center",
                    fontSize: { xs: "24px", md: "48px" },
                    lineHeight: { xs: "22px", md: "44px" },
                    whiteSpace: "pre-line",
                  }}
                >
                  {window.innerWidth <= 600
                    ? "Ramzan puzzle!\nFinal moments." // Break into two lines on xs
                    : "Ramzan puzzle! Final moments."}{" "}
                  {/* Single line for md+ */}
                </TypographyComponent>
                <TypographyComponentNormal
                  sx={{
                    color: Colors.typoblue3,
                    fontSize: { xs: "8px", md: "12px" },
                    lineHeight: { xs: "12px", md: "16px" },
                  }}
                >
                  Gone in Seconds ! Don’t Miss Your Chance!
                </TypographyComponentNormal>
              </Box>
            </Box>
            <Box
              sx={{
                width: { xs: "40%", md: "15%" },
                display: "flex",
                flexDirection: "column",
                height: "100%",
                justifyContent: "center", // Center horizontally
                alignItems: "center", // Center vertically
              }}
            >
              <img
                src={isMobile ? cupMobile : cup}
                alt="Description"
                style={{
                  width: isMobile ? "134px" : "100%",
                  height: isMobile ? "131px" : "100%",
                  objectFit: "cover",
                }}
              />
              <PlayButtonComponent
                sx={{
                  width: { md: "182px", xs: "96px" },
                  display: { xs: "flex", md: "none" },
                }}
              ></PlayButtonComponent>
            </Box>
          </Box>
        ))}
      </Slider>
    </Container>
  );
};

export default SliderComponent;
